<plex-layout>
    <plex-layout-main>
        <app-bi-queries></app-bi-queries>
    </plex-layout-main>
</plex-layout>